import { render, staticRenderFns } from "./CAMAssignment.vue?vue&type=template&id=7e650a46"
import script from "./CAMAssignment.vue?vue&type=script&lang=js"
export * from "./CAMAssignment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports